export default __webpack_public_path__ + "static/g20-logo-3d971fc808575e2b9a21e537668d4aa1.png";